import Button from '@package/components/Button';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';

const Body = ({ data, isEditMode }) => {
  const { title, description, label, href, openLinkInNewTab } = data;

  return (
    <div className="hero-block">
      <BodyClass className="has-hero-image" />
      <Container>
        <h1>{title}</h1>
        <p>{description}</p>
        {label ? (
          <Button
            invert
            large
            href={href?.[0]?.['@id']}
            openLinkInNewTab={openLinkInNewTab}
          >
            {label}
          </Button>
        ) : null}
      </Container>
    </div>
  );
};

Body.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),

  isEditMode: PropTypes.bool,
};

export default Body;
